import React from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import './CustomButton.css';

const CustomButton = ({ text, onClick, variant, size, className, showArrow = true }) => {
  return (
    <Button 
      className={`custom-pill-btn btn-${variant} btn-sz-${size} ${className} d-flex align-items-center ${showArrow ? 'gap-3' : ''}`}
      onClick={onClick}
      style={{ paddingRight: showArrow ? '8px' : '30px' }}
    >
      <span className="btn-text">{text}</span>
      {showArrow && (
        <span className="arrow-circle">
          <FaArrowRight />
        </span>
      )}
    </Button>
  );
};

export default CustomButton;